module.exports = __webpack_public_path__ + "img/favicon_livet.6c76da62.svg";